module.exports = __webpack_public_path__ + "assets/img/shop_index.585fc51b.png";